import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import BZAPIService from '../../services/BZAPIService';

const DeleteProjectModal = ({ isOpen, toggle, project, projects, setProjects }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleRemoveProject = async () => {
    setIsDeleting(true);
    try {
      const { id } = project;
      await BZAPIService.bsaDeleteProject(id);
      setProjects(projects.filter(p => p.id !== project.id));
      toggle();
    } catch (error) {
      console.error('Failed to delete project:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={!isDeleting ? toggle : undefined}>
      <ModalHeader toggle={!isDeleting ? toggle : undefined}>Delete project {project.name}</ModalHeader>
      <ModalBody>
        {isDeleting ? (
          <div className="text-center py-4">
            <Spinner color="danger" style={{ width: '3rem', height: '3rem' }} />
            <p className="mt-3 mb-0" style={{ color: '#64748b' }}>
              Deleting project...
            </p>
          </div>
        ) : (
          <p>Are you sure you want to delete this project?</p>
        )}
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="bz-btn bz-btn--primary"
          onClick={handleRemoveProject}
          disabled={isDeleting}
          style={{ minWidth: '140px' }}
        >
          {isDeleting ? (
            <>
              <Spinner size="sm" className="me-2" /> Deleting...
            </>
          ) : (
            'Delete project'
          )}
        </button>{' '}
        <button type="button" className="bz-btn" onClick={toggle} disabled={isDeleting} style={{ minWidth: '140px' }}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

DeleteProjectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  setProjects: PropTypes.func.isRequired
};

export default DeleteProjectModal;
